import React, { useContext, useState, useEffect } from "react";
import { Container, Row, Col, Button, Table, Form } from "react-bootstrap";
import "./Create.css";
import Select from "react-select";
import Header from "../../../Header/Header";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import { Link, useParams } from "react-router-dom";
import { Context } from "../../../../utils/context";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import classNames from "classnames";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ModalSave from "../../../common/ModelSave";
import { useNavigate } from "react-router";
import { putData } from "../../../../utils/api";
import JoditEditor from "jodit-react";
import { variant_type } from "../../../../utils/common";
import DoubleVarient from "../DoubleVarient";
function Edit() {
  const { id } = useParams();

  const navigate = useNavigate();
  const {
    getData,
    editStatusData,
    deleteData,
    ErrorNotify,
    isAllow,
    Per_Page_Dropdown,
    Select2Data,
    usertype,
    IMG_URL,
    postData,
    getDimension,
  } = useContext(Context);

  const [loading, setLoading] = useState(true);
  const [submitLoading, setSubmitLoading] = useState(false);
  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    reset,
    watch,
    getValues,
    setValue,
    trigger,
  } = useForm({
    defaultValues: {
      variants: [
        {
          name: "",
          price: "",
          franchisee_price: "",
          mrp: "",
          member_price: "",
          image: "",
          description: "",
          status: true,
          out_of_stock_status: false,
        },
      ], // Default empty field
    },
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "variants",
  });
  const variantType = watch("variant_type_id");

  const isJoiningKit = watch("is_joining_kit")?.value;

  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const [existingImages, setExistingImages] = useState([]);
  const [deletedImages, setDeletedImages] = useState([]);

  const imageFiles = watch("images");

  const onSubmit = async (data) => {
    try {
      setSubmitLoading(true);
      const DataToSend = new FormData();
      DataToSend.append("name", data?.name);
      DataToSend.append("price", data?.price);
      // DataToSend.append("mrp", data?.mrp);

      DataToSend.append("manufacturer", data?.manufacturer);
      DataToSend.append("description", data?.description);
      DataToSend.append("features", data?.features);
      DataToSend.append("specification", data?.specification);
      DataToSend.append("care", data?.care);
      DataToSend.append("delivery", data?.delivery);
      DataToSend.append("warranty", data?.warranty);
      DataToSend.append("tax_percentage", data?.tax_percentage);
      DataToSend.append("p_category_id", data?.p_category_id?.value);
      DataToSend.append("p_sub_category_id", data?.p_sub_category_id?.value);
      DataToSend.append("shape_id", data?.shape_id?.value);

      // if (data?.variant_type_id?.value) {
      DataToSend.append("variant_type_id", variant_type.Single);
      // }

      if (data?.p_child_category_id?.value) {
        DataToSend.append(
          "p_child_category_id",
          data?.p_child_category_id?.value,
        );
      }

      DataToSend.append("unit_id", data?.unit_id?.value);

      if (data?.is_joining_kit?.value) {
        DataToSend.append("is_joining_kit", data?.is_joining_kit?.value);
      }
      // if (data?.joining_bonus && isJoiningKit) {
      //   DataToSend.append("joining_bonus", data?.joining_bonus);
      // }

      DataToSend.append("item_code", data?.item_code);
      DataToSend.append("lic_no", data?.lic_no);
      DataToSend.append("tag", data?.tag);
      if (data?.measurements)
        DataToSend.append("measurements", data?.measurements);
      DataToSend.append("expity_date_days", data?.expity_date_days);
      DataToSend.append("delivery_charges", data?.delivery_charges);

      // if (data?.preservation_status) {
      DataToSend.append("preservation_status", data?.preservation_status);
      // }

      // if (data?.advantages_status) {
      DataToSend.append("advantages_status", data?.advantages_status);
      // }

      // if (data?.composition_status) {
      DataToSend.append("composition_status", data?.composition_status);
      // }

      // if (data?.description_status) {
      DataToSend.append("description_status", data?.description_status);
      // }

      DataToSend.append("made_in_id", data?.made_in_id?.value);

      const imageFile = data.image?.[0];

      console.log("Image:", imageFile);
      console.log("Is File:", imageFile instanceof File);
      console.log("Name:", imageFile?.name);
      console.log("Size:", imageFile?.size);
      console.log("Type:", imageFile?.type);

      if (imageFile instanceof File) {
        DataToSend.append("image", imageFile);
      }

      // if (data?.image && data?.image[0]) {
      //   DataToSend.append("image", data.image[0]);
      // }
      if (data?.video && data?.video[0]) {
        DataToSend.append("video", data.video[0]);
      }

      for (const [key, value] of DataToSend.entries()) {
        console.log(
          key,
          value instanceof File
            ? {
                name: value.name,
                size: value.size,
                type: value.type,
              }
            : value,
        );
      }

      // Append the images (multiple files)
      // if (data?.images && data?.images.length > 0) {
      //   for (let i = 0; i < data.images.length; i++) {
      //     DataToSend.append("images", data.images[i]);
      //   }
      // }

      // const inputImages = document.getElementById(`variantImages`);
      // if (inputImages && inputImages.files) {
      //   const files = inputImages.files;
      //   for (let i = 0; i < files.length; i++) {
      //     DataToSend.append(`images`, files[i]);
      //   }
      // }

      if (imagePreviews && imagePreviews.length > 0) {
        for (let i = 0; i < imagePreviews.length; i++) {
          if (imagePreviews[i].file) {
            DataToSend.append("images", imagePreviews[i].file);
          }
        }
      } else if (data?.images && data?.images.length > 0) {
        // Fallback: if data.images has files directly
        for (let i = 0; i < data.images.length; i++) {
          if (data.images[i] instanceof File) {
            DataToSend.append("images", data.images[i]);
          }
        }
      }

      if (deletedImages.length > 0) {
        DataToSend.append("deleted_images", JSON.stringify(deletedImages));
      }

      const variants = [];

      data.variants?.forEach((variant) => {
        const singleVariant = {
          id: variant?.id,
          price: variant?.price ?? null,
          cashback_amount: variant?.cashback_amount ?? null,
          franchisee_price: variant?.franchisee_price ?? null,
          mrp: variant?.mrp ?? null,
          member_price: variant?.member_price ?? null,
          metal_id: variant?.metal_id ?? null,
          description: variant?.description ?? null,
          double_variants: [],
          status: variant?.status,
          out_of_stock_status: variant?.out_of_stock_status,
        };

        if (Array.isArray(variant?.double_variants)) {
          variant.double_variants.forEach((doubleVal) => {
            const doubleVariant = {
              id: doubleVal?.id,
              mrp: doubleVal?.mrp ?? null,
              price: doubleVal?.price ?? null,
              size_id: doubleVal?.size_id ?? null,
              triple_variants: [],
            };

            if (Array.isArray(doubleVal?.triple_variants)) {
              doubleVal.triple_variants.forEach((tripleVal) => {
                doubleVariant.triple_variants.push({
                  id: tripleVal?.id,
                  mrp: tripleVal?.mrp ?? null,
                  price: tripleVal?.price ?? null,
                  diamond_id: tripleVal?.diamond_id ?? null,
                });
              });
            }

            singleVariant.double_variants.push(doubleVariant);
          });
        }

        variants.push(singleVariant);
      });
      DataToSend.append("variants", JSON.stringify(variants));

      if (data?.levels?.length > 0) {
        DataToSend.append("level_commission", JSON.stringify(data?.levels));
      }
      // if (data?.levels?.length > 0 && !isJoiningKit) {
      //   DataToSend.append("level_commission", JSON.stringify(data?.levels));
      // }
      let response;
      if (data?.name) {
        response = await putData(`/admin/products/${id}`, DataToSend);
      }

      if (response?.success) {
        await setShowModal({ code: response.code, message: response.data });
        reset();
        setTimeout(() => {
          setShowModal(0);
          navigate("/products");
        }, 1000);
      } else {
        await setShowModal({ code: response?.code, message: response?.errors });
        setTimeout(() => {
          setShowModal(0);
        }, 1000);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setSubmitLoading(false);
    }
  };

  const [Countries, setCountries] = useState([]);

  const [brands, setBrands] = useState([]);
  const [units, setUnits] = useState([]);
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [childCategories, setChildCategories] = useState([]);
  const [Farmer, setFarmer] = useState([]);
  const [DeliveryType, setDeliveryType] = useState([]);
  const [shapes, setShape] = useState([]);

  const [level, setLevel] = useState([]);

  const getAllLevel = async () => {
    const response = await getData(`/common/masters/all-level?status=true`);
    if (response?.success) {
      setLevel(await Select2Data(response?.data, "level_id"));
    }
  };

  const getAllUnits = async () => {
    const response = await getData(`/common/masters/all-units`);
    if (response?.success) {
      const result = response?.data?.map((data) => ({
        value: data?.id,
        label: data?.name,
        name: "unit_id",
        sub_name: `${data?.commission_unit_value || ""} ${data?.commission_unit || ""}`,
      }));

      setUnits(result);
    }
  };
  const getAllCategories = async () => {
    const response = await getData("/common/masters/all-p-category");
    if (response?.success) {
      setCategories(await Select2Data(response?.data, "p_category_id"));
    }
  };
  const getAllSubCategories = async (id) => {
    const response = await getData(`/common/masters/all-p-sub-category/${id}`);
    if (response?.success) {
      setSubCategories(await Select2Data(response?.data, "p_sub_category_id"));
    }
  };

  useEffect(() => {
    getAllLevel();
    getAllUnits();
    getAllCategories();
  }, []);

  const GetEditData = async () => {
    try {
      setLoading(true);
      const response = await getData(`/admin/products/${id}`);
      reset(response?.data);
      if (response?.data?.images && Array.isArray(response.data.images)) {
        const formattedImages = response.data.images.map((img) => ({
          url: IMG_URL + img.image, // Adjust based on your API response structure
          type: img.image?.match(/\.(mp4|mov|avi|webm|ogg)$/i)
            ? "video"
            : "image",
          name: img.image,
        }));
        setExistingImages(formattedImages);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    GetEditData();
  }, [id]);

  const [imagePreview, setImagePreview] = useState(null); // State to store image preview
  const imageFile = watch("image");

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImagePreview(URL.createObjectURL(file));
    }
    // if (file) {
    //   const reader = new FileReader();
    //   reader.onloadend = () => {
    //     setImagePreview(reader.result); // Set image preview
    //   };
    //   reader.readAsDataURL(file);
    // }
  };

  const [imagePreviews, setImagePreviews] = useState([]);

  // const handleImagesChange = (e) => {
  //   const files = e.target.files;
  //   if (files) {
  //     const previews = [];
  //     Array.from(files).forEach((file) => {
  //       const reader = new FileReader();
  //       reader.onloadend = () => {
  //         previews.push(reader.result);
  //         if (previews.length === files.length) {
  //           setImagePreviews(previews);
  //         }
  //       };
  //       reader.readAsDataURL(file);
  //     });
  //   }
  // };

  const handleImagesChange = (e) => {
    const files = Array.from(e.target.files || []);

    if (files.length === 0) {
      setValue("images", []);
      setImagePreviews([]);
      trigger("images");
      return;
    }

    const allowedImageTypes = [
      "image/jpeg",
      "image/png",
      "image/gif",
      "image/webp",
    ];
    const allowedVideoTypes = ["video/mp4", "video/webm", "video/ogg"];
    const allowedTypes = [...allowedImageTypes, ...allowedVideoTypes];
    const maxSize = 10 * 1024 * 1024;

    const validFiles = [];
    const previewPromises = files.map((file) => {
      return new Promise((resolve) => {
        if (!allowedTypes.includes(file.type)) {
          ErrorNotify(
            `File ${file.name} is not allowed. Only images and videos are allowed.`,
          );
          resolve(null);
          return;
        }

        if (file.size > maxSize) {
          ErrorNotify(`File ${file.name} exceeds 10MB`);
          resolve({
            url: "",
            type: file.type.startsWith("video") ? "video" : "image",
            file: null,
            error: "File too large",
          });
          return;
        }

        validFiles.push(file);

        const reader = new FileReader();
        reader.onloadend = () => {
          resolve({
            url: reader.result,
            type: file.type.startsWith("video") ? "video" : "image",
            file,
            isExisting: false,
          });
        };
        reader.readAsDataURL(file);
      });
    });

    Promise.all(previewPromises).then((results) => {
      const newPreviews = results.filter(Boolean);

      setImagePreviews((prev) => {
        const updated = [...prev, ...newPreviews];

        // keep only actual valid files
        const allFiles = updated.map((item) => item.file).filter(Boolean);
        setValue("images", allFiles, { shouldValidate: true });

        return updated;
      });

      trigger("images");
    });
  };

  const [videoPreviews, setVideoPreview] = useState(null);

  const handleVideoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setVideoPreview(reader.result); // Set image preview
      };
      reader.readAsDataURL(file);
    }
  };

  const [Metals, setMetal] = useState([]);
  const getAllMetal = async () => {
    const response = await getData(`/common/masters/all-metal`);
    if (response?.success) {
      setMetal(await Select2Data(response?.data, "metal_id"));
    }
  };

  const [Sizes, setSize] = useState([]);
  const getAllSize = async () => {
    const response = await getData(`/common/masters/all-size`);
    if (response?.success) {
      setSize(await Select2Data(response?.data, "size_id"));
    }
  };

  const [Diamonds, setDiamond] = useState([]);
  const getAllDiamond = async () => {
    const response = await getData(`/common/masters/all-diamond`);
    if (response?.success) {
      setDiamond(await Select2Data(response?.data, "diamond_id"));
    }
  };
  const [VarientType, setVarientType] = useState([]);
  const getAllVarientType = async () => {
    const response = await getData(`/common/masters/all-variant-type`);
    if (response?.success) {
      setVarientType(await Select2Data(response?.data, "stock_type_id"));
    }
  };

  useEffect(() => {
    getAllSize();
    getAllMetal();
    getAllVarientType();
  }, []);

  const unit_id = watch("unit_id");

  const handleVarientImagesChange = (e) => {
    const files = Array.from(e.target.files || []);
    const urls = files.map((file) => ({
      id: null,
      url: URL.createObjectURL(file),
    }));

    setImagePreviews((prev) => [...(prev || []), ...urls]);
  };

  const handleRemoveImage = async (imageIndex) => {
    const targetImage = imagePreviews[imageIndex];

    // Optional confirm
    if (!window.confirm("Are you sure you want to delete this image?")) return;

    // If it's a server image (has an id), delete from server
    if (targetImage?.id) {
      try {
        await deleteData(`/admin/products/image-delete/${targetImage.id}`);
        console.log("Image deleted from server:", targetImage.id);
      } catch (err) {
        console.error("Failed to delete image:", err);
        alert("Failed to delete image from server.");
        return;
      }
    }

    // Remove from preview state
    setImagePreviews((prev) => {
      const updatedImages = [...prev];
      updatedImages.splice(imageIndex, 1);
      return updatedImages;
    });
  };

  const removeMedia = (indexToRemove, isExisting = false, imageName = null) => {
    if (isExisting) {
      if (imageName) {
        setDeletedImages((prev) => [...prev, imageName]);
      }

      setExistingImages((prev) => {
        const updatedExisting = prev.filter(
          (_, index) => index !== indexToRemove,
        );

        // after removing existing image, revalidate based on remaining existing + new previews
        const currentNewFiles = imagePreviews
          .map((p) => p.file)
          .filter(Boolean);
        setValue("images", currentNewFiles, { shouldValidate: true });

        return updatedExisting;
      });
    } else {
      const updatedPreviews = imagePreviews.filter(
        (_, index) => index !== indexToRemove,
      );
      setImagePreviews(updatedPreviews);

      const remainingFiles = updatedPreviews.map((p) => p.file).filter(Boolean);
      setValue("images", remainingFiles, { shouldValidate: true });
    }

    trigger("images");
  };

  return (
    <>
      <Header title={"Edit Product"} link={"/employee/employee_details"} />
      <section className="Create">
        {/* back button start */}
        <div className="back_btn_holder">
          <div onClick={() => navigate(`/products`)}>
            <FontAwesomeIcon className="back-btn" icon={faAngleLeft} />
            Back
          </div>
        </div>
        {/* back button end */}
        {loading ? (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ minHeight: "300px" }}
          >
            <div className="spinner-border text-primary" />
          </div>
        ) : (
          <Form onSubmit={handleSubmit(onSubmit)}>
            {/* 1. Order Details start */}
            <div className="oder-detail-holder mb-3">
              <div className="heading-holder">
                <h6>1. Product Category</h6>
              </div>
              <div className="package-details-section">
                <div className="pending-table ">
                  <div className="row ">
                    <div className="col-xxl-2 col-xl-3  col-lg-4  col-md-2 col-12 mb-2">
                      <Form.Label>Category</Form.Label>
                      <Controller
                        className="select-contoller"
                        name={`p_category_id`} // name of the field
                        control={control}
                        rules={{
                          required: "Select Category",
                        }}
                        render={({
                          field: { onChange, onBlur, value, ref },
                        }) => (
                          <Select
                            styles={{
                              control: (baseStyles) => ({
                                ...baseStyles,
                                borderColor: errors?.p_category_id
                                  ? "red"
                                  : baseStyles.borderColor,
                              }),
                            }}
                            // {...field}
                            options={categories}
                            onChange={(selectedValue) => {
                              onChange(selectedValue);
                              getAllSubCategories(selectedValue?.value);
                              setValue("p_sub_category_id", "");
                            }}
                            onBlur={onBlur}
                            value={value}
                            ref={ref}
                          />
                        )}
                      />
                      {errors.p_category_id && (
                        <span className="text-danger">
                          {errors.p_category_id.message}
                        </span>
                      )}
                    </div>

                    <div className="col-xxl-2 col-xl-3  col-lg-4  col-md-2 col-12 mb-2">
                      <Form.Label>Sub Category</Form.Label>
                      <Controller
                        className="select-contoller"
                        name={`p_sub_category_id`} // name of the field
                        control={control}
                        rules={{
                          required: "Select Sub Category",
                        }}
                        render={({
                          field: { onChange, onBlur, value, ref },
                        }) => (
                          <Select
                            styles={{
                              control: (baseStyles) => ({
                                ...baseStyles,
                                borderColor: errors?.p_sub_category_id
                                  ? "red"
                                  : baseStyles.borderColor,
                              }),
                            }}
                            // {...field}
                            options={subCategories}
                            onChange={(selectedValue) => {
                              onChange(selectedValue);
                            }}
                            onBlur={onBlur}
                            value={value}
                            ref={ref}
                          />
                        )}
                      />
                      {errors.p_sub_category_id && (
                        <span className="text-danger">
                          {errors.p_sub_category_id.message}
                        </span>
                      )}
                    </div>

                    {/* <div className="col-xxl-2 col-xl-3  col-lg-4  col-md-2 col-12 mb-2">
                      <Form.Label>Expiry Date Alert Days</Form.Label>
                      <Form.Control
                        type="text"
                        name="expity_date_days"
                        placeholder="Expiry Date Alert Days"
                        className={classNames("", {
                          "is-invalid": errors?.expity_date_days,
                        })}
                        {...register("expity_date_days", {
                          // required: "Expiry Date Alert Days is required",
                        })}
                        onKeyDown={(e) => {
                          // Allow: Backspace, Tab, Arrow keys, Delete
                          if (
                            [
                              "Backspace",
                              "Tab",
                              "ArrowLeft",
                              "ArrowRight",
                              "Delete",
                            ].includes(e.key)
                          ) {
                            return;
                          }

                          // Prevent non-numeric keys
                          if (!/^[0-9]$/.test(e.key)) {
                            e.preventDefault();
                          }
                        }}
                      />

                      {errors.expity_date_days && (
                        <span className="text-danger">
                          {errors.expity_date_days.message}
                        </span>
                      )}
                    </div> */}
                  </div>
                </div>
              </div>
            </div>

            {/* 2. Package Details start */}
            <div className="oder-detail-holder mb-3">
              <div className="heading-holder">
                <h6>2. Product</h6>
              </div>
              <div className="package-details-section">
                <Row>
                  <Col>
                    {/* Package Weight */}
                    <Row className="detail-row">
                      <Col md={6}>
                        <div className="detail-label">Name</div>
                      </Col>
                      <Col lg={6} md={6}>
                        <div className="d-flex align-items-center">
                          <Form.Control
                            type="text"
                            name={`name`}
                            placeholder="name"
                            maxLength={50}
                            className={classNames("", {
                              "is-invalid": errors?.name, // Adjusted error checking
                            })}
                            {...register(`name`, {
                              required: "name is required",
                              // validate: (value) =>
                              //   value.length <= 200 ||
                              //   "Data must be 200 characters or less",
                              maxLength: {
                                value: 50,
                                message: "Name must be 50 characters or less",
                              },
                            })}
                          />
                        </div>
                        {errors.name && (
                          <span className="text-danger">
                            {errors.name.message}
                          </span>
                        )}
                      </Col>
                    </Row>

                    <Row className="detail-row">
                      <Col md={6}>
                        <div className="detail-label">
                          Thumbnail Upload image (928 × 945 px).
                        </div>
                      </Col>
                      <Col lg={6} md={6}>
                        <div className="d-flex align-items-center">
                          <Form.Control
                            type="file"
                            name="image"
                            accept="image/jpeg,image/png,image/webp"
                            className={classNames("", {
                              "is-invalid": errors?.image,
                            })}
                            {...register("image", {
                              // validate: async (value) => {
                              //   if (
                              //     typeof value !== "string" &&
                              //     value &&
                              //     value[0]
                              //   ) {
                              //     const file = value[0];
                              //     const fileTypes = [
                              //       "jpg",
                              //       "jpeg",
                              //       "png",
                              //       "webp",
                              //     ];
                              //     const fileType = file.name
                              //       .split(".")
                              //       .pop()
                              //       .toLowerCase();
                              //     if (!fileTypes.includes(fileType)) {
                              //       return `Please upload a valid file format. (${fileTypes.join(
                              //         ", ",
                              //       )})`;
                              //     }
                              //     const sizes = await getDimension(file);
                              //     if (
                              //       sizes.width !== 928 ||
                              //       sizes.height !== 945
                              //     ) {
                              //       return "Image width and height must be 928 px and 945 px";
                              //     }
                              //     const fileSize = Math.round(file.size / 1024); // in KB
                              //     if (fileSize > 500) {
                              //       return "File size must be less than 500KB";
                              //     }
                              //   }
                              // },
                            })}
                            // onChange={handleImageChange}
                          />
                        </div>

                        {errors.image && (
                          <span className="text-danger">
                            {errors.image.message}
                          </span>
                        )}
                      </Col>
                    </Row>

                    <Row className="detail-row">
                      <Col md={6}>
                        <div className="detail-label">Unit</div>
                      </Col>
                      <Col lg={6} md={6}>
                        <div className=" ">
                          <Controller
                            className="select-contoller "
                            name={`unit_id`} // name of the field
                            control={control}
                            rules={{
                              required: "Select Unit",
                            }}
                            render={({
                              field: { onChange, onBlur, value, ref },
                            }) => (
                              <Select
                                styles={{
                                  control: (baseStyles) => ({
                                    ...baseStyles,
                                    borderColor: errors?.unit_id
                                      ? "red"
                                      : baseStyles.borderColor,
                                  }),
                                }}
                                // {...field}
                                options={units}
                                onChange={(selectedValue) => {
                                  onChange(selectedValue);
                                }}
                                onBlur={onBlur}
                                value={value}
                                ref={ref}
                              />
                            )}
                          />
                        </div>
                        {errors.unit_id && (
                          <span className="text-danger">
                            {errors.unit_id.message}
                          </span>
                        )}
                      </Col>
                    </Row>

                    <Row className="detail-row">
                      <Col md={6}>
                        <div className="detail-label"> Landing Price</div>
                      </Col>
                      <Col lg={6} md={6}>
                        <div className="d-flex align-items-center">
                          <Form.Control
                            type="text"
                            name={`price`} // Register color for the variant
                            placeholder="Farmotsav Landing Price"
                            className={classNames("", {
                              "is-invalid": errors?.price,
                            })}
                            {...register(`price`, {
                              required: "Farmotsav Landing Price is required",
                            })}
                            onKeyDown={(e) => {
                              // Allow backspace, left and right arrow keys
                              if (
                                e.key === "Backspace" ||
                                e.key === "ArrowLeft" ||
                                e.key === "ArrowRight"
                              ) {
                                return; // Allow the action to continue
                              }

                              // Allow digits and decimal point
                              if (!/[\d.]/.test(e.key)) {
                                e.preventDefault(); // Block the invalid key
                              }

                              // Prevent multiple decimal points
                              if (
                                e.key === "." &&
                                e.target.value.includes(".")
                              ) {
                                e.preventDefault(); // Block adding another decimal point
                              }
                            }}
                          />
                        </div>
                        {errors.price && (
                          <span className="text-danger">
                            {errors.price.message}
                          </span>
                        )}
                      </Col>
                    </Row>

                    <Row className="detail-row">
                      <Col md={6}>
                        <div className="detail-label">Delivery Chargers</div>
                        {unit_id?.value && (
                          <small className="text-danger d-block mt-1">
                            *Enter Delivery charges For{" "}
                            {unit_id?.sub_name || ""}
                          </small>
                        )}
                      </Col>

                      <Col lg={6} md={6}>
                        <div className=" ">
                          <Form.Control
                            type="text"
                            name={`delivery_charges`}
                            placeholder="Delivery Chargers"
                            className={classNames("", {
                              "is-invalid": errors?.delivery_charges, // Adjusted error checking
                            })}
                            {...register(`delivery_charges`, {
                              required: "Delivery Chargers is required",

                              min: {
                                value: 0,
                                message:
                                  "Amount must be greater than or equal to 0",
                              },

                              validate: (value) =>
                                Number(value) >= 0 ||
                                "Invalid delivery Chargers",
                            })}
                          />
                        </div>
                        {errors.delivery_charges && (
                          <span className="text-danger">
                            {errors.delivery_charges.message}
                          </span>
                        )}
                      </Col>
                    </Row>

                    <Row className="detail-row">
                      <Col md={6}>
                        <div className="detail-label">Is Joining Kit</div>
                      </Col>

                      <Col lg={6} md={6}>
                        <Controller
                          name="is_joining_kit"
                          control={control}
                          defaultValue={{
                            value: false,
                            label: "No",
                          }}
                          rules={{
                            required: "Select Joining Kit Status",
                          }}
                          render={({
                            field: { onChange, onBlur, value, ref },
                          }) => (
                            <Select
                              styles={{
                                control: (baseStyles) => ({
                                  ...baseStyles,
                                  borderColor: errors?.is_joining_kit
                                    ? "red"
                                    : baseStyles.borderColor,
                                }),
                              }}
                              options={[
                                { value: true, label: "Yes" },
                                { value: false, label: "No" },
                              ]}
                              onChange={(selectedValue) => {
                                onChange(selectedValue);
                              }}
                              onBlur={onBlur}
                              value={value}
                              ref={ref}
                            />
                          )}
                        />

                        {errors.is_joining_kit && (
                          <span className="text-danger">
                            {errors.is_joining_kit.message}
                          </span>
                        )}
                      </Col>
                    </Row>

                    {/* {isJoiningKit && (
                      <Row className="detail-row">
                        <Col md={6}>
                          <div className="detail-label">Joining Bonus</div>
                        </Col>
                        <Col lg={6} md={6}>
                          <div className="d-flex align-items-center">
                            <Form.Control
                              type="text"
                              name={`joining_bonus`}
                              placeholder="Joining Bonus"
                              className={classNames("", {
                                "is-invalid": errors?.joining_bonus, // Adjusted error checking
                              })}
                              {...register(`joining_bonus`, {
                                required: "Joining Bonus is required",

                                min: {
                                  value: 1,
                                  message:
                                    "Amount must be greater than or equal to 1",
                                },

                                validate: (value) =>
                                  Number(value) >= 1 || "Invalid joining Bonus",
                              })}
                            />
                          </div>
                          {errors.joining_bonus && (
                            <span className="text-danger">
                              {errors.joining_bonus.message}
                            </span>
                          )}
                        </Col>
                      </Row>
                    )} */}
                  </Col>

                  <Col lg={4} md={4} className="ms-5">
                    {typeof getValues("image") === "string" ? (
                      // If image is a string (URL), show the preview
                      <div className="image-preview-container ms-5">
                        <img
                          src={IMG_URL + getValues("image")}
                          alt="Preview"
                          className="image-preview"
                          width={50}
                        />
                      </div>
                    ) : (
                      // If the image is not a string (i.e., it's a file or URL in preview), show that
                      imageFile &&
                      imageFile?.length > 0 && (
                        <div className="image-preview-container ms-5">
                          <img
                            // src={imagePreview}

                            src={URL?.createObjectURL(imageFile[0])}
                            alt="Category Preview"
                            width={150}
                          />
                        </div>
                      )
                    )}
                  </Col>
                </Row>
              </div>
            </div>
            {/* 2. Package Details end */}

            {/* 3. Pickup Slot Details start */}
            <div className="oder-detail-holder mb-3">
              <div className="heading-holder">
                <h6>3. Details</h6>
              </div>

              <div className="package-details-section">
                <Row className="detail-row">
                  <Col md={4}>
                    <div className="main-form-section mt-3">
                      <Row className="justify-content-center">
                        <Form.Label>Tax Percentage</Form.Label>
                        <Form.Group>
                          <Form.Control
                            type="text"
                            name="tax_percentage"
                            placeholder="Tax Percentage (%)"
                            className={classNames("", {
                              "is-invalid": errors?.tax_percentage,
                            })}
                            {...register("tax_percentage", {
                              validate: (value) => {
                                // Optional field
                                if (!value || value.trim() === "") {
                                  return true;
                                }

                                const numericValue = parseFloat(value);

                                if (isNaN(numericValue)) {
                                  return "Please enter a valid tax percentage";
                                }

                                if (numericValue < 0) {
                                  return "Tax percentage cannot be negative";
                                }

                                if (numericValue > 100) {
                                  return "Tax percentage cannot exceed 100";
                                }

                                return true;
                              },
                            })}
                            onKeyDown={(e) => {
                              if (
                                !/[0-9]/.test(e.key) &&
                                e.key !== "Backspace" &&
                                e.key !== "ArrowLeft" &&
                                e.key !== "ArrowRight" &&
                                e.key !== "." &&
                                e.key !== "Tab" &&
                                e.key !== "Delete"
                              ) {
                                e.preventDefault();
                              }

                              if (
                                e.key === "." &&
                                e.target.value.includes(".")
                              ) {
                                e.preventDefault();
                              }
                            }}
                            onChange={(e) => {
                              const value = e.target.value;

                              if (value && parseFloat(value) > 100) {
                                e.target.value = "100";
                              }
                            }}
                          />
                          {errors.tax_percentage && (
                            <span className="text-danger">
                              {errors.tax_percentage.message}
                            </span>
                          )}
                        </Form.Group>
                      </Row>
                    </div>
                  </Col>

                  <Col md={4}>
                    <div className="main-form-section mt-3">
                      <Row className="justify-content-center">
                        <Form.Label>License No</Form.Label>
                        <Form.Group>
                          <Form.Control
                            type="text"
                            name={`lic_no`}
                            placeholder="License No"
                            maxLength={200}
                            className={classNames("", {
                              "is-invalid": errors?.lic_no, // Adjusted error checking
                            })}
                            {...register(`lic_no`, {
                              // required: "License No is required",
                              maxLength: {
                                value: 200,
                                message: "Name must be 200 characters or less",
                              },
                            })}
                          />
                          {errors.lic_no && (
                            <span className="text-danger">
                              {errors.lic_no.message}
                            </span>
                          )}
                        </Form.Group>
                      </Row>
                    </div>
                  </Col>

                  <Col md={4}>
                    <div className="main-form-section mt-3">
                      <Row className="justify-content-center">
                        <Form.Label>HSN Code</Form.Label>
                        <Form.Group>
                          <Form.Control
                            type="text"
                            name={`HSN Code`}
                            maxLength={200}
                            placeholder="HSN Code"
                            className={classNames("", {
                              "is-invalid": errors?.tag, // Adjusted error checking
                            })}
                            {...register(`tag`, {
                              // required: "License No is required",
                              maxLength: {
                                value: 200,
                                message:
                                  "HSN Code must be 200 characters or less",
                              },
                            })}
                          />
                          {errors.tag && (
                            <span className="text-danger">
                              {errors.tag.message}
                            </span>
                          )}
                        </Form.Group>
                      </Row>
                    </div>
                  </Col>
                  <Col md={4}>
                    <div className="main-form-section mt-3">
                      <Row className="justify-content-center">
                        <Form.Label>Shelf Life</Form.Label>
                        <Form.Group>
                          <Form.Control
                            type="text"
                            name={`Shelf Life`}
                            maxLength={200}
                            placeholder="Shelf Life"
                            className={classNames("", {
                              "is-invalid": errors?.measurements, // Adjusted error checking
                            })}
                            {...register(`measurements`, {
                              // required: "License No is required",
                              maxLength: {
                                value: 200,
                                message:
                                  "Shelf Life must be 200 characters or less",
                              },
                            })}
                          />
                          {errors.measurements && (
                            <span className="text-danger">
                              {errors.measurements.message}
                            </span>
                          )}
                        </Form.Group>
                      </Row>
                    </div>
                  </Col>
                </Row>
                <Row className="detail-row">
                  <Col md={12}>
                    <div className="main-form-section mt-3">
                      <Row className="justify-content-center">
                        <Form.Label>Description</Form.Label>
                        <Form.Group>
                          <Controller
                            name="description"
                            control={control}
                            rules={{
                              required: "description is required.",
                            }} // Correct the maxLength rule
                            render={({
                              field: { onChange, onBlur, value },
                            }) => (
                              <JoditEditor
                                value={value}
                                onBlur={() => {
                                  onBlur();
                                  trigger("description");
                                }}
                                onChange={onChange}
                              />
                            )}
                          />
                          {errors.description && (
                            <span className="text-danger">
                              {errors.description.message}
                            </span>
                          )}
                        </Form.Group>
                      </Row>
                    </div>
                  </Col>
                </Row>

                <Row className="detail-row">
                  <Col md={12}>
                    <div className="main-form-section mt-3">
                      <Row className="justify-content-center">
                        <Form.Label>Packaging & Delivery</Form.Label>
                        <Form.Group>
                          <Controller
                            name="delivery"
                            control={control}
                            rules={{
                              required: "Packaging & Delivery is required.",
                            }} // Correct the maxLength rule
                            render={({
                              field: { onChange, onBlur, value },
                            }) => (
                              <JoditEditor
                                value={value}
                                onBlur={() => {
                                  onBlur();
                                  trigger("delivery");
                                }}
                                onChange={onChange}
                              />
                            )}
                          />
                          {errors.delivery && (
                            <span className="text-danger">
                              {errors.delivery.message}
                            </span>
                          )}
                        </Form.Group>
                      </Row>
                    </div>
                  </Col>
                </Row>

                {/* <Row className="detail-row">
                <Col md={12}>
                  <div className="main-form-section mt-3">
                    <Row className="justify-content-center">
                      <Form.Label>
                        Suggested Use

                      </Form.Label>
                      <Form.Group>
                        <Controller
                          name="care"
                          control={control}
                          rules={{
                            required: "Suggested Use is required.",

                          }} // Correct the maxLength rule
                          render={({ field: { onChange, onBlur, value } }) => (
                            <JoditEditor
                              value={value}
                              onBlur={() => {
                                onBlur();
                                trigger("care");
                              }}
                              onChange={onChange}
                            />
                          )}
                        />
                        {errors.care && (
                          <span className="text-danger">
                            {errors.care.message}
                          </span>
                        )}
                      </Form.Group>
                    </Row>
                  </div>
                </Col>
              </Row> */}

                {/* <Row className="detail-row">
                <Col md={12}>
                  <div className="main-form-section mt-3">
                    <Row className="justify-content-center">
                      <Form.Label>
                        Other Ingredients

                      </Form.Label>
                      <Form.Group>
                        <Controller
                          name="specification"
                          control={control}
                          rules={{
                            required: " Other Ingredients is required.",

                          }} // Correct the maxLength rule
                          render={({ field: { onChange, onBlur, value } }) => (
                            <JoditEditor
                              value={value}
                              onBlur={() => {
                                onBlur();
                                trigger("specification");
                              }}
                              onChange={onChange}
                            />
                          )}
                        />
                        {errors.specification && (
                          <span className="text-danger">
                            {errors.specification.message}
                          </span>
                        )}
                      </Form.Group>
                    </Row>
                  </div>
                </Col>
              </Row> */}

                <Row className="detail-row">
                  <Col md={12}>
                    <div className="main-form-section mt-3">
                      <Row className="justify-content-center">
                        <Form.Label>Additional Feature</Form.Label>
                        <Form.Group>
                          <Controller
                            name="features"
                            control={control}
                            rules={{
                              required: "Additional Feature is required.",
                            }}
                            render={({
                              field: { onChange, onBlur, value },
                            }) => (
                              <JoditEditor
                                value={value}
                                onBlur={() => {
                                  onBlur();
                                  trigger("features");
                                }}
                                onChange={onChange}
                              />
                            )}
                          />
                          {errors.features && (
                            <span className="text-danger">
                              {errors.features.message}
                            </span>
                          )}
                        </Form.Group>
                      </Row>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
            {/* 3. Pickup Slot Details end */}

            <div className="oder-detail-holder mb-3">
              <div className="heading-holder">
                <h6>4. Images Upload image (928 × 945 px).</h6>
              </div>
              <div className="package-details-section">
                {/* Pickup Slot */}
                <Row className="detail-row">
                  {/* <Col lg={4} md={4}>
                    <div className="d-flex align-items-center">
                      <Form.Control
                        className={classNames("", {
                          "is-invalid": errors?.images,
                        })}
                        type="file"
                        multiple
                        {...register(`images`, {
                          // required: "Images are required",
                        })}
                        accept="image/*"
                        id={`variantImages`}
                        onChange={(e) => handleVarientImagesChange(e)}
                      />
                    </div>
                    {errors.images && (
                      <span className="text-danger">
                        {errors.images.message}
                      </span>
                    )}
                  </Col> */}

                  <Col lg={4} md={4}>
                    <div className="d-flex align-items-center">
                      <Form.Control
                        type="file"
                        name="images"
                        multiple
                        placeholder="Media"
                        className={classNames("", {
                          "is-invalid": errors?.images,
                        })}
                        {...register("images", {
                          validate: (value) => {
                            const hasExisting = existingImages.length > 0;
                            const hasNewPreviews = imagePreviews.some(
                              (item) => item?.file,
                            );
                            const hasFilesInInput = value && value.length > 0;

                            // If either old images OR new uploaded images exist, validation should pass
                            if (
                              hasExisting ||
                              hasNewPreviews ||
                              hasFilesInInput
                            ) {
                              return true;
                            }

                            return "Media file (image) is required";
                          },
                        })}
                        accept="image/jpeg,image/png,image/webp"
                        onChange={handleImagesChange}
                      />
                    </div>
                    {errors.images && (
                      <span className="text-danger">
                        {errors.images.message}
                      </span>
                    )}
                  </Col>

                  <div className="img-row-holder d-flex flex-wrap">
                    {/* Show Existing Images from Server */}

                    {/* {existingImages && existingImages.length > 0 && existingImages.map((image, index) => {
                    const isVideo = image.type === "video";
                    return (
                      <div className="mt-2 mx-3 position-relative" key={`existing-${index}`}>
                        {isVideo ? (
                          <video
                            src={image.url}
                            controls
                            style={{ maxWidth: "100px", maxHeight: "100px" }}
                            className="rounded"
                          />
                        ) : (
                          <img
                            src={image.url}
                            alt={`Existing Media ${index}`}
                            style={{ maxWidth: "100px", maxHeight: "100px", objectFit: "cover" }}
                            className="rounded"
                          />
                        )}
                        <button
                          type="button"
                          onClick={() => removeMedia(index, true, image.name)}
                          className="position-absolute top-0 end-0 bg-danger text-white rounded-circle border-0"
                          style={{ width: "20px", height: "20px", fontSize: "12px", lineHeight: "1" }}
                        >
                          ×
                        </button>
                      </div>
                    );
                  })} */}

                    {existingImages &&
                      existingImages.length > 0 &&
                      existingImages.map((image, index) => {
                        if (!image || !image.url) return null;
                        const isVideo = image.type === "video";
                        return (
                          <div
                            className="mt-2 mx-3 position-relative"
                            key={`existing-${index}`}
                          >
                            {isVideo ? (
                              <video
                                src={image.url}
                                controls
                                style={{
                                  maxWidth: "100px",
                                  maxHeight: "100px",
                                }}
                                className="rounded"
                              />
                            ) : (
                              <img
                                src={image.url}
                                alt={`Existing Media ${index}`}
                                style={{
                                  maxWidth: "100px",
                                  maxHeight: "100px",
                                  objectFit: "cover",
                                }}
                                className="rounded"
                              />
                            )}
                            <button
                              type="button"
                              onClick={() =>
                                removeMedia(index, true, image.name)
                              }
                              className="position-absolute top-0 end-0 bg-danger text-white rounded-circle border-0"
                              style={{
                                width: "20px",
                                height: "20px",
                                fontSize: "12px",
                                lineHeight: "1",
                              }}
                            >
                              ×
                            </button>
                          </div>
                        );
                      })}

                    {imagePreviews &&
                      imagePreviews.length > 0 &&
                      imagePreviews.map((image, index) => {
                        if (!image || !image.url) return null;
                        const isVideo = image.type === "video";
                        return (
                          <div
                            className="mt-2 mx-3 position-relative"
                            key={`new-${index}`}
                          >
                            {isVideo ? (
                              <video
                                src={image.url}
                                controls
                                style={{
                                  maxWidth: "100px",
                                  maxHeight: "100px",
                                }}
                                className="rounded"
                              />
                            ) : (
                              <img
                                src={image.url}
                                alt={`New Media Preview ${index}`}
                                style={{
                                  maxWidth: "100px",
                                  maxHeight: "100px",
                                  objectFit: "cover",
                                }}
                                className="rounded"
                              />
                            )}
                            <button
                              type="button"
                              onClick={() => removeMedia(index, false)}
                              className="position-absolute top-0 end-0 bg-danger text-white rounded-circle border-0"
                              style={{
                                width: "20px",
                                height: "20px",
                                fontSize: "12px",
                                lineHeight: "1",
                              }}
                            >
                              ×
                            </button>
                          </div>
                        );
                      })}
                  </div>
                </Row>
              </div>
            </div>
            {/* {!isJoiningKit && ( */}
            <div className="oder-detail-holder mb-3">
              <div className="heading-holder">
                <h6>5. Product Level Commissions</h6>
              </div>
              <div className="package-details-section">
                {unit_id?.value && (
                  <small className="text-danger d-block mt-1">
                    *You will be entering commission per{" "}
                    {unit_id?.sub_name || ""}
                  </small>
                )}
                {/* Pickup Slot */}
                <Row className="detail-row">
                  {level?.map((level, index) => (
                    <Col md={6} lg={4} key={level.value}>
                      <div
                        className="main-form-section mt-3 p-3"
                        style={{
                          border: "1px solid #ddd",
                          borderRadius: "10px",
                        }}
                      >
                        <h5 className="mb-3">{level.label}</h5>

                        {/* Commission Percentage */}
                        <Form.Group className="mb-3">
                          <Form.Label>Commission Percentage (%)</Form.Label>

                          <Form.Control
                            type="number"
                            step="0.01"
                            placeholder="Enter Percentage"
                            className={classNames("", {
                              "is-invalid": errors?.levels?.[index]?.percent,
                            })}
                            {...register(`levels.${index}.percent`, {
                              // required: "Commission Percentage is required",

                              min: {
                                value: 1,
                                message:
                                  "Percentage must be greater than or equal to 1",
                              },

                              max: {
                                value: 100,
                                message:
                                  "Percentage cannot be greater than 100",
                              },

                              validate: (value) => {
                                if (
                                  value === undefined ||
                                  value === null ||
                                  value === ""
                                ) {
                                  return true;
                                }

                                return (
                                  Number(value) >= 0 ||
                                  "Invalid percentage amount"
                                );
                              },
                            })}
                          />

                          {errors?.levels?.[index]?.percent && (
                            <span className="text-danger">
                              {errors?.levels?.[index]?.percent?.message}
                            </span>
                          )}
                        </Form.Group>

                        {/* Commission Amount */}
                        <Form.Group>
                          <Form.Label>Commission Amount</Form.Label>

                          <Form.Control
                            type="number"
                            step="0.01"
                            placeholder="Enter Amount"
                            className={classNames("", {
                              "is-invalid": errors?.levels?.[index]?.amount,
                            })}
                            {...register(`levels.${index}.amount`, {
                              // required: "Commission Amount is required",

                              min: {
                                value: 1,
                                message:
                                  "Amount must be greater than or equal to 1",
                              },

                              validate: (value) => {
                                if (
                                  value === undefined ||
                                  value === null ||
                                  value === ""
                                ) {
                                  return true;
                                }

                                return (
                                  Number(value) >= 0 ||
                                  "Invalid commission amount"
                                );
                              },
                            })}
                          />

                          {errors?.levels?.[index]?.amount && (
                            <span className="text-danger">
                              {errors?.levels?.[index]?.amount?.message}
                            </span>
                          )}
                        </Form.Group>
                        <input
                          type="hidden"
                          value={level.value}
                          {...register(`levels.${index}.level_id`)}
                        />
                      </div>
                    </Col>
                  ))}
                </Row>
              </div>
            </div>
            {/* )} */}
            <div className="oder-detail-holder mb-3">
              <div className="heading-holder">
                {/* <h6>5.{variantType?.label} Variants</h6> */}
                <h6>6. Variants</h6>
              </div>

              <div className="package-details-section">
                {fields.map((variant, index) => (
                  <div key={variant.id} className="main-form-section mt-3">
                    <Row>
                      <Col md={4}>
                        <div className="main-form-section mt-3">
                          <Row className="justify-content-center">
                            <Form.Label>
                              Variant {index + 1}{" "}
                              {unit_id?.value ? ` (${unit_id?.label})` : ""}
                            </Form.Label>
                            <Form.Group>
                              <Controller
                                className="select-contoller"
                                name={`variants.${index}.metal_id`}
                                control={control}
                                rules={{
                                  required: `Enter Variant ${index + 1}`,
                                  validate: (value) => {
                                    if (
                                      value === "" ||
                                      value === null ||
                                      value === undefined
                                    ) {
                                      return `Enter Variant ${index + 1}`;
                                    }

                                    // Allow only positive numbers and decimals
                                    const regex = /^\d+(\.\d+)?$/;

                                    return (
                                      regex.test(value) ||
                                      "Only positive numbers and decimals are allowed"
                                    );
                                  },
                                }}
                                render={({
                                  field: { onChange, onBlur, value, ref },
                                }) => (
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder={`Enter Variant ${index + 1}`}
                                    onChange={(e) => {
                                      let inputValue = e.target.value;

                                      // Remove invalid characters
                                      inputValue = inputValue.replace(
                                        /[^0-9.]/g,
                                        "",
                                      );

                                      // Prevent multiple decimals
                                      const parts = inputValue.split(".");
                                      if (parts.length > 2) {
                                        inputValue =
                                          parts[0] +
                                          "." +
                                          parts.slice(1).join("");
                                      }

                                      onChange(inputValue);
                                    }}
                                    onBlur={onBlur}
                                    value={value || ""}
                                    ref={ref}
                                    style={{
                                      borderColor: errors?.variants?.[index]
                                        ?.metal_id
                                        ? "red"
                                        : undefined,
                                    }}
                                  />
                                )}
                              />

                              {errors?.variants?.[index]?.metal_id && (
                                <span className="text-danger">
                                  {errors?.variants?.[index]?.metal_id.message}
                                </span>
                              )}
                            </Form.Group>
                          </Row>
                        </div>
                      </Col>

                      <Col md={4}>
                        <div className="main-form-section mt-3">
                          <Row className="justify-content-center">
                            <Form.Label>Farmotsav MRP</Form.Label>
                            <Form.Group>
                              <Form.Control
                                type="text"
                                name={`variants.${index}.mrp`} // Register color for the variant
                                placeholder="Farmotsav MRP"
                                className={classNames("", {
                                  "is-invalid": errors?.variants?.[index]?.mrp,
                                })}
                                {...register(`variants.${index}.mrp`, {
                                  required: "Farmotsav MRP is required",
                                })}
                                onKeyDown={(e) => {
                                  // Allow backspace, left and right arrow keys
                                  if (
                                    e.key === "Backspace" ||
                                    e.key === "ArrowLeft" ||
                                    e.key === "ArrowRight"
                                  ) {
                                    return; // Allow the action to continue
                                  }

                                  // Allow digits and decimal point
                                  if (!/[\d.]/.test(e.key)) {
                                    e.preventDefault(); // Block the invalid key
                                  }

                                  // Prevent multiple decimal points
                                  if (
                                    e.key === "." &&
                                    e.target.value.includes(".")
                                  ) {
                                    e.preventDefault(); // Block adding another decimal point
                                  }
                                }}
                              />
                              {errors?.variants?.[index]?.mrp && (
                                <span className="text-danger">
                                  {errors.variants[index].mrp.message}
                                </span>
                              )}
                            </Form.Group>
                          </Row>
                        </div>
                      </Col>
                      <Col md={4}>
                        <div className="main-form-section mt-3">
                          <Row className="justify-content-center">
                            <Form.Label>Farmotsav Discounted Price</Form.Label>
                            <Form.Group>
                              <Form.Control
                                type="text"
                                name={`variants.${index}.price`} // Register color for the variant
                                placeholder="Farmotsav Discounted Price"
                                className={classNames("", {
                                  "is-invalid":
                                    errors?.variants?.[index]?.price,
                                })}
                                {...register(`variants.${index}.price`, {
                                  required:
                                    "Farmotsav Discounted Price is required",
                                  validate: {
                                    lessThanPrice: (value) => {
                                      const mrp = getValues(
                                        `variants.${index}.mrp`,
                                      );
                                      if (
                                        parseFloat(value) >= parseFloat(mrp)
                                      ) {
                                        return "Price must be less than MRP";
                                      }
                                      return true;
                                    },
                                  },
                                })}
                                onKeyDown={(e) => {
                                  // Allow backspace, left and right arrow keys
                                  if (
                                    e.key === "Backspace" ||
                                    e.key === "ArrowLeft" ||
                                    e.key === "ArrowRight"
                                  ) {
                                    return; // Allow the action to continue
                                  }

                                  // Allow digits and decimal point
                                  if (!/[\d.]/.test(e.key)) {
                                    e.preventDefault(); // Block the invalid key
                                  }

                                  // Prevent multiple decimal points
                                  if (
                                    e.key === "." &&
                                    e.target.value.includes(".")
                                  ) {
                                    e.preventDefault(); // Block adding another decimal point
                                  }
                                }}
                              />
                              {errors?.variants?.[index]?.price && (
                                <span className="text-danger">
                                  {errors.variants[index].price.message}
                                </span>
                              )}
                            </Form.Group>
                          </Row>
                        </div>
                      </Col>
                      {!isJoiningKit && (
                        <Col md={4}>
                          <div className="main-form-section mt-3">
                            <Row className="justify-content-center">
                              <Form.Label>Member Discounted Price</Form.Label>
                              <Form.Group>
                                <Form.Control
                                  type="text"
                                  name={`variants.${index}.member_price`}
                                  placeholder="Member Discounted Price"
                                  className={classNames("", {
                                    "is-invalid":
                                      errors?.variants?.[index]?.member_price,
                                  })}
                                  {...register(
                                    `variants.${index}.member_price`,
                                    {
                                      validate: {
                                        lessThanMemberMrp: (value) => {
                                          const mrp = getValues(
                                            `variants.${index}.mrp`,
                                          );
                                          if (
                                            value &&
                                            mrp &&
                                            parseFloat(value) >= parseFloat(mrp)
                                          ) {
                                            return "Member price must be less than MRP";
                                          }
                                          return true;
                                        },
                                      },
                                    },
                                  )}
                                  onKeyDown={(e) => {
                                    if (
                                      e.key === "Backspace" ||
                                      e.key === "ArrowLeft" ||
                                      e.key === "ArrowRight"
                                    ) {
                                      return;
                                    }
                                    if (!/[\d.]/.test(e.key)) {
                                      e.preventDefault();
                                    }
                                    if (
                                      e.key === "." &&
                                      e.target.value.includes(".")
                                    ) {
                                      e.preventDefault();
                                    }
                                  }}
                                />
                                {errors?.variants?.[index]?.member_price && (
                                  <span className="text-danger">
                                    {
                                      errors.variants[index].member_price
                                        .message
                                    }
                                  </span>
                                )}
                              </Form.Group>
                            </Row>
                          </div>
                        </Col>
                      )}
                      <Col md={4}>
                        <div className="main-form-section mt-3">
                          <Row className="justify-content-center">
                            <Form.Label>Farmotsav Franchisee Price</Form.Label>
                            <Form.Group>
                              <Form.Control
                                type="text"
                                name={`variants.${index}.franchisee_price`} // Register color for the variant
                                placeholder="Variant Price"
                                className={classNames("", {
                                  "is-invalid":
                                    errors?.variants?.[index]?.franchisee_price,
                                })}
                                {...register(
                                  `variants.${index}.franchisee_price`,
                                  {
                                    required:
                                      "Farmotsav Franchisee Price is required",
                                  },
                                )}
                                onKeyDown={(e) => {
                                  // Allow backspace, left and right arrow keys
                                  if (
                                    e.key === "Backspace" ||
                                    e.key === "ArrowLeft" ||
                                    e.key === "ArrowRight"
                                  ) {
                                    return; // Allow the action to continue
                                  }

                                  // Allow digits and decimal point
                                  if (!/[\d.]/.test(e.key)) {
                                    e.preventDefault(); // Block the invalid key
                                  }

                                  // Prevent multiple decimal points
                                  if (
                                    e.key === "." &&
                                    e.target.value.includes(".")
                                  ) {
                                    e.preventDefault(); // Block adding another decimal point
                                  }
                                }}
                              />
                              {errors?.variants?.[index]?.franchisee_price && (
                                <span className="text-danger">
                                  {
                                    errors.variants[index].franchisee_price
                                      .message
                                  }
                                </span>
                              )}
                            </Form.Group>
                          </Row>
                        </div>
                      </Col>
                      <Col md={4}>
                        <div className="main-form-section mt-3">
                          <Row className="justify-content-center">
                            <Form.Label>Cashback Amount</Form.Label>
                            <Form.Group>
                              <Form.Control
                                type="text"
                                name={`variants.${index}.cashback_amount`} // Register color for the variant
                                placeholder="Cashback Amount"
                                className={classNames("", {
                                  "is-invalid":
                                    errors?.variants?.[index]?.cashback_amount,
                                })}
                                {...register(
                                  `variants.${index}.cashback_amount`,
                                  {
                                    required: "Cashback Amount is required",
                                  },
                                )}
                                onKeyDown={(e) => {
                                  // Allow backspace, left and right arrow keys
                                  if (
                                    e.key === "Backspace" ||
                                    e.key === "ArrowLeft" ||
                                    e.key === "ArrowRight"
                                  ) {
                                    return; // Allow the action to continue
                                  }

                                  // Allow digits and decimal point
                                  if (!/[\d.]/.test(e.key)) {
                                    e.preventDefault(); // Block the invalid key
                                  }

                                  // Prevent multiple decimal points
                                  if (
                                    e.key === "." &&
                                    e.target.value.includes(".")
                                  ) {
                                    e.preventDefault(); // Block adding another decimal point
                                  }
                                }}
                              />
                              {errors?.variants?.[index]?.cashback_amount && (
                                <span className="text-danger">
                                  {
                                    errors.variants[index].cashback_amount
                                      .message
                                  }
                                </span>
                              )}
                            </Form.Group>
                          </Row>
                        </div>
                      </Col>
                      <Col md={4}>
                        <div className="main-form-section mt-3">
                          <Row className="justify-content-center">
                            {/* Status */}
                            <Form.Label> Status</Form.Label>

                            <Form.Group className="form-check form-switch">
                              <Form.Check
                                type="checkbox"
                                role="switch"
                                id={`variants.${index}.status`}
                                label="Status"
                                {...register(`variants.${index}.status`)}
                              />
                            </Form.Group>
                          </Row>
                        </div>
                      </Col>

                      <Col md={4}>
                        <div className="main-form-section mt-3">
                          <Row className="justify-content-center">
                            {/* Out of Stock Status */}
                            <Form.Label> Out of Stock Status</Form.Label>
                            <Form.Group className="mb-3 form-check form-switch">
                              <Form.Check
                                type="checkbox"
                                role="switch"
                                id={`variants.${index}.out_of_stock_status`}
                                label="Out of Stock"
                                {...register(
                                  `variants.${index}.out_of_stock_status`,
                                )}
                              />
                            </Form.Group>
                          </Row>
                        </div>
                      </Col>
                    </Row>
                    {fields.length > 1 && (
                      <button
                        className="mt-3 add-varient"
                        type="button"
                        onClick={() => remove(index)} // Remove the variant
                      >
                        Remove Variant
                      </button>
                    )}
                    <hr />
                  </div>
                ))}
              </div>
              <hr />
              <div className="text-center">
                <button
                  type="button"
                  className="add-varient"
                  onClick={() =>
                    append({ status: true, out_of_stock_status: false })
                  }
                >
                  + Add Variant
                </button>
              </div>
            </div>
            {/* ) : Number(variantType?.value) === variant_type.Double ? (
          <div className="oder-detail-holder mb-3">
            <div className="heading-holder">
              <h6>5.{variantType?.label} Variants</h6>
            </div>

            <div className="package-details-section">
              {fields.map((variant, index) => (
                <div key={variant.id} className="main-form-section mt-3">
                  <Row>
                    <Col md={4}>
                      <div className="main-form-section mt-3">
                        <Form.Group>
                          <div className="">
                            <Form.Label>Variant 1</Form.Label>
                          </div>

                          <Controller
                            className="select-contoller"
                            name={`variants.${index}.metal_id`}
                            control={control}
                            rules={{
                              required: "Enter Variant 1",
                            }}
                            render={({ field: { onChange, onBlur, value, ref } }) => (
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Variant 1"
                                onChange={(e) => onChange(e.target.value)}
                                onBlur={onBlur}
                                value={value || ""}
                                ref={ref}
                                style={{
                                  borderColor: errors?.variants?.[index]?.metal_id
                                    ? "red"
                                    : undefined,
                                }}
                              />
                            )}
                          />

                          {errors?.variants?.[index]?.metal_id && (
                            <span className="text-danger">
                              {errors?.variants?.[index]?.metal_id.message}
                            </span>
                          )}
                        </Form.Group>
                      </div>
                    </Col>
                    <DoubleVarient
                      product_id={getValues(`variants.${index}.product_id`)}
                      singleIndex={index}
                      control={control}
                      variantType={variantType}
                      register={register}
                      getValues={getValues}
                      errors={errors}
                      setValue={setValue}
                    />
                  </Row>
                  {fields.length > 1 && (
                    <button
                      className="mt-3 add-varient"
                      type="button"
                      onClick={() => remove(index)} // Remove the variant
                    >
                      Remove Variant
                    </button>
                  )}
                  <hr />
                </div>
              ))}
            </div>
            <hr />
            <div className="text-center">
              <button
                type="button"
                className="add-varient"
                onClick={() => append({})}
              >
                + Add Variant
              </button>
            </div>
          </div>
          ) : Number(variantType?.value) === variant_type.Triple ? (
          <div className="oder-detail-holder mb-3">
            <div className="heading-holder">
              <h6>5.{variantType?.label} Variants</h6>
            </div>

            <div className="package-details-section">
              {fields.map((variant, index) => (
                <div key={variant.id} className="main-form-section mt-3">
                  <Row>
                    <Col md={4}>
                      <div className="main-form-section mt-3">
                        <Form.Group>
                          <div className="">
                            <Form.Label>Variant 1</Form.Label>
                          </div>

                          <Controller
                            className="select-contoller"
                            name={`variants.${index}.metal_id`}
                            control={control}
                            rules={{
                              required: "Enter Variant 1",
                            }}
                            render={({ field: { onChange, onBlur, value, ref } }) => (
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Variant 1"
                                onChange={(e) => onChange(e.target.value)}
                                onBlur={onBlur}
                                value={value || ""}
                                ref={ref}
                                style={{
                                  borderColor: errors?.variants?.[index]?.metal_id
                                    ? "red"
                                    : undefined,
                                }}
                              />
                            )}
                          />

                          {errors?.variants?.[index]?.metal_id && (
                            <span className="text-danger">
                              {errors?.variants?.[index]?.metal_id.message}
                            </span>
                          )}
                        </Form.Group>
                      </div>
                    </Col>

                    <DoubleVarient
                      variantType={variantType}
                      singleIndex={index}
                      control={control}
                      register={register}
                      getValues={getValues}
                      errors={errors}
                      setValue={setValue}
                    />
                  </Row>
                  {fields.length > 1 && (
                    <button
                      className="mt-3 add-varient"
                      type="button"
                      onClick={() => remove(index)} // Remove the variant
                    >
                      Remove Variant
                    </button>
                  )}
                  <hr />
                </div>
              ))}
            </div>
            <hr />
            <div className="text-center">
              <button
                type="button"
                className="add-varient"
                onClick={() => append({})}
              >
                + Add Variant
              </button>
            </div>
          </div>
          ) : null} */}
            {/* warning text-end */}
            <div className="d-flex justify-content-center">
              <div className="text-center mt-4 mx-2">
                <button
                  className="Back-button"
                  type="submit"
                  onClick={() => navigate("/products")}
                >
                  Cancel
                </button>
              </div>

              <div className="text-center mt-4 mx-2">
                <button
                  // type="button"
                  className="schedule-button"
                  onClick={onSubmit}
                  disabled={submitLoading}
                >
                  {submitLoading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      Updating...
                    </>
                  ) : (
                    "Update Product"
                  )}
                </button>
              </div>
            </div>
          </Form>
        )}

        <ModalSave
          message={showModal.message}
          showErrorModal={showModal.code ? true : false}
        />
      </section>
    </>
  );
}

export default Edit;
